import styled from "styled-components";

export const ProgressBar = styled.div`
  background-color: #d8d8d8;
  border-radius: 20px;
  height: 10px;
  display: inline-block;
  width: 88%;
  max-width: 400px;
  margin-left: 8px;
`;

export const ProgressDone = styled.div`
  background: linear-gradient(to left, #73b301, ${(props) => props.theme.themeGlobal.positive});
  border-radius: 20px;
  color: #fff;
  justify-content: center;
  height: 100%;
  transition: 1s ease 0.3s;
  width: 0;
  width: ${(props) => props.width}%;
  animation: progressBar 3s ease-in-out;
  animation-fill-mode: both;
`;

export const ProgressBarWrapper = styled.div`
  margin: 0 auto;
  padding: 3px 0 8px 0;
  width: 100%;
  border-bottom: 2px dotted #eee;
  z-index: 50;
  background: white;
  top: 0;
  left: 0;
  right: 0;
  height: 18px;
  max-width: 500px;
`;

export const ProgressValue = styled.span`
  display: inline-block;
  color: #8e8e8e;
  font-size: 1rem;
  width: 8%;
`;
